<template>
    <b-modal @hide="handleFecharModal" no-close-on-backdrop no-close-on-esc header-bg-variant="dark" header-text-variant="light" :id="'modal-gerenciar-solicitacao-agendamento-' + agendamento.id" size="xl" hide-footer centered title="AGENDAMENTO">
    <div class="d-flex flex-column flex-lg-row gap-sm">
        <b-card class="tamanhoCardInfo d-flex flex-column gap-sm" header-bg-variant="secondary" header-text-variant="light">
            <template #header >
                <div class="w-100 text-center">
                    <strong>
                    INFORMAÇÕES
                    </strong>
                </div>
            </template>
            <div class="d-flex flex-column mb-5">
                <span style="font-size: 25px;">{{ agendamento.funcionario }}</span>
                <span style="color: grey;">{{ agendamento.solicitante }}</span>
            </div>
            <b-row class="mb-4">
                <b-col sm="12" md="12" lg="6" class="d-flex flex-column">
                    <label class="labelGray">CPF</label>
                    <strong>{{ $options.filters.addMascara(agendamento.cpf, "cpf") }}</strong>
                </b-col>
                <b-col sm="12" md="12" lg="6" class="d-flex flex-column">
                    <label class="labelGray">CBO</label>
                    <strong>{{ $options.filters.addMascara(agendamento.cbo, "cbo") }}</strong>
                </b-col>
            </b-row>
            <b-row class="mb-5">
                <b-col sm="12" md="12" lg="12" class="d-flex flex-column">
                    <label class="labelGray">Cargo</label>
                    <strong>{{ agendamento.cargo }}</strong>
                </b-col>
            </b-row>
            <b-row class="mb-5">
                <b-col sm="12" md="12" lg="6" class="d-flex flex-column">
                    <label class="labelGray">Período</label>
                    <strong>{{ agendamento.periodo }}</strong>
                </b-col>
                <b-col sm="12" md="12" lg="6" class="d-flex flex-column">
                    <label class="labelGray">Exame</label>
                    <strong>{{ agendamento.exame }}</strong>
                </b-col>
            </b-row>
        </b-card>
        <div class="tamanhoAgendamentos d-flex flex-column gap-sm">
            <b-form class="p-1">
            <b-form-row class="mb-2">
                <b-col sm="12" md="12" lg="12">
                    <label>Exames a Realizar</label>
                    <autoCompleteExame :value="exameSelecionado" @exameSelecionado="handleExameSelected"/>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col sm="12" md="12" lg="6">
                    <label>Horário</label>
                    <b-form-timepicker minutes-step="15" label-close-button="Fechar" v-model="novoHorarioAgendado.horario" locale="pt-br" label-no-time-selected="Nenhum horário selecionado"></b-form-timepicker>
                </b-col>
                <b-col sm="12" md="12" lg="6">
                    <label>Data</label>
                    <b-form-datepicker :min="new Date()" label-selected="Data Selecionada" label-help v-model="novoHorarioAgendado.dia" class="mb-2" label-no-date-selected="Nenhuma data selecionada"></b-form-datepicker>
                </b-col>
            </b-form-row>
            <div class="d-flex w-100 gap-sm mt-3">
                <b-button variant="secondary" size="sm" @click.prevent="limparFormularioNovoAgendamento">Limpar</b-button>
                <b-button variant="primary" size="sm" @click.prevent="adicionarNovoAgendamento" :disabled="agendamento.situacao == 'Cancelado'">Adicionar</b-button>
            </div>
        </b-form>
        <div v-if="agendamentos.length == 0" class="d-flex flex-row justify-content-center align-items-center h-75 mt-3" style="background-color: hsl(0, 0%, 50%, 0.2);border-radius: 10px;">
			<span style="color: gray; font-size: 18px;">
				Nenhum exame especificado
			</span>
		</div>
        <b-table v-else striped hover :items="agendamentos" :fields="fields" :responsive="true">
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(exame)="data">
                    {{ data.item.exame.exame ? data.item.exame.exame :  data.item.exame}}
                </template>
                <template #cell(dia)="data">
					{{  $options.filters.moment(data.item.dia).format("DD/MM/YYYY") }}
                </template>
                <template #cell(horario)="data">
                    {{  data.item.horario.substring(0, 5) }}
                </template>
				<template #cell(acao)="data">
					<b-button variant="dark" size="sm" v-if="data.item.idExameAgendado" @click="$bvModal.show('modal-cancelar-exame-' + data.item.idExameAgendado)">Cancelar</b-button>
					<modalCancelarExameAgendado @exameCancelado="handleExameCancelado($event)" :exameAgendado="data.item"/>
				</template>
        </b-table>
        <div class="w-100 d-flex justify-content-end gap-sm mt-auto">
            <b-button variant="outline-danger" size="lg" @click.prevent="abrirModalCancelarAgendamento" :disabled="agendamento.situacao == 'Cancelado'">Cancelar</b-button>
            <b-button variant="outline-success" size="lg" :disabled="carregandoAgendarHorario || novosAgendamentos.length == 0 || agendamento.situacao == 'Cancelado'" @click.prevent="realizarAgendamento">
            	<span v-show="!carregandoAgendarHorario">
                	Agendar
            	</span>
            	<b-spinner v-show="carregandoAgendarHorario" variant="success" class="mx-auto"></b-spinner>
            </b-button>
        </div>
        </div>

		<modalCancelarAgendamento @agendamentoCancelado="handleAgendamentoCancelado" :agendamento="agendamento"/>
    </div>

	</b-modal>
</template>

<script>
import AutoCompleteExame from "./AutoCompleteExame.vue";
import ExameAgendadoService from "../../service/ExameAgendadoService.js";
import ModalCancelarAgendamento from "./ModalCancelarAgendamento.vue";
import ModalCancelarExameAgendado from "./ModalCancelarExameAgendado.vue";

export default{
	name: "ModalGerenciarSolicitacaoAgendamento.vue",
	components: {
		autoCompleteExame: AutoCompleteExame,
		modalCancelarAgendamento: ModalCancelarAgendamento,
		modalCancelarExameAgendado: ModalCancelarExameAgendado,
	},
	props: [ "agendamento" ],
	data() {
		return {
			carregandoCancelarAgendamento: false,
			carregandoAgendarHorario: false,
			exameSelecionado: "",
			novoHorarioAgendado: {
				exame: "",
				horario: "",
				dia: "",
			},
			agendamentos: [],
			fields: [
				{
					key: "index",
					label: "#",
				},
				{
					key: "exame",
					label: "Exame",
				},
				{
					key: "dia",
					label: "Dia",
				},
				{
					key: "horario",
					label: "Horário",
				},
				{
					key: "acao",
					label: "",
				},
			],
			novosAgendamentos: [],
		};
	},
	created() {
		this.consultarExamesAgendados();
	},
	methods: {
		handleExameCancelado(id) {
			this.mensagem("Exame Cancelado Com Sucesso!", "Sucesso", "success");
			this.$bvModal.hide("modal-cancelar-exame-" + id);
			this.consultarExamesAgendados();
		},
		handleAgendamentoCancelado() {
			this.$emit("agendamentoCancelado");
		},
		abrirModalCancelarAgendamento() {
			this.$bvModal.show("modal-cancelar-agendamento-" + this.agendamento.id);
		},
		handleFecharModal() {
			this.agendamentos = [];
			this.novosAgendamentos = [];
			this.limparFormularioNovoAgendamento();
		},
		consultarExamesAgendados() {
			ExameAgendadoService.consultar(this.agendamento.id)
				.then((res) => {
					this.agendamentos = res.data;
				}).catch((err) => {
					console.log(err);
				});
		},
		limparFormularioNovoAgendamento() {
			this.exameSelecionado = "";
			this.novoHorarioAgendado.exame = "";
			this.novoHorarioAgendado.dia = "";
			this.novoHorarioAgendado.horario = "";
		},
		validaAdicionarNovoAgendamento() {
			if (!this.novoHorarioAgendado.exame) {
				this.mensagem("É necessário selecionar um Exame", "Aviso", "warning");
				return false;
			}
			if (!this.novoHorarioAgendado.horario) {
				this.mensagem("É necessário selecionar um Horário", "Aviso", "warning");
				return false;
			}
			if (!this.novoHorarioAgendado.dia) {
				this.mensagem("É necessário selecionar uma Data", "Aviso", "warning");
				return false;
			}

			return true;
		},
		validaAgendamentoJaExistente(novoHorarioAgendado) {
			const index = this.agendamentos.find(a => a.dia == novoHorarioAgendado.dia && a.exame.id == novoHorarioAgendado.exame.id && a.horario == novoHorarioAgendado.horario);
			if (!index) {
				return true;
			} else {
				this.mensagem("Já existe um agendamento marcado para esse dia, horário e exame selecionados", "Aviso", "warning");
				return false;
			}
		},
		async validaAgendamentoJaExistenteEtapaInterna(obj) {
			let deuBom = false;
			const request = {
				idAgendamento: this.agendamento.id,
				idExame: obj.exame.id,
				dia: this.$options.filters.moment(obj.dia).format("DD/MM/YYYY"),
				horario: obj.horario,
			};

			 await ExameAgendadoService.validar(request)
				.then(() => {
					deuBom = true;
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Aviso", "warning");
					} else {
						this.mensagem("Não foi possível realizar o agendamento, por favor tente novamente mais tarde.", "Aviso", "warning");
					}
					deuBom = false;
				});

			return deuBom;
		},
		montaRequestAgendamento() {
			const request = [];
			this.novosAgendamentos.forEach((a) => {
				request.push(
					{
						idAgendamento: this.agendamento.id,
						idExame: a.exame.id,
						dia: this.$options.filters.moment(a.dia).format("DD/MM/YYYY"),
						horario: a.horario,
					},
				);
			});
			return request;
		},
		async adicionarNovoAgendamento() {
			const obj = JSON.parse(JSON.stringify(this.novoHorarioAgendado));
			if (!this.validaAdicionarNovoAgendamento()) {
				return;
			}
			if (!this.validaAgendamentoJaExistente(obj)) {
				return;
			}

			const deuBom = await this.validaAgendamentoJaExistenteEtapaInterna(obj);
			if (deuBom) {
				this.agendamentos.push(obj);
				this.novosAgendamentos.push(obj);
				this.limparFormularioNovoAgendamento();
			}
		},
		realizarAgendamento() {
			this.carregandoAgendarHorario = true;
			const request = this.montaRequestAgendamento();

			ExameAgendadoService.salvar(request)
				.then(() => {
					this.$bvModal.hide("modal-gerenciar-solicitacao-agendamento-" + this.agendamento.id);
				})
				.then(() => {
					this.$emit("agendamentoRealizado");
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Aviso", "danger");
					} else {
						this.mensagem("Não foi possível realizar o agendamento", "Aviso", "danger");
					}
				})
				.finally(() => {
					this.carregandoAgendarHorario = false;
				});
		},
		handleExameSelected(exame) {
			this.exameSelecionado = exame.exame;
			this.novoHorarioAgendado.exame = exame;
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},

	},
};

</script>


<style>

.labelGray{
    color: gray;
}
.tamanhoCardInfo{
    width: 35%;
}
.tamanhoAgendamentos{
    width: 65%;
}
@media screen and (max-width:1200px){
    .tamanhoCardInfo,.tamanhoAgendamentos{
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Agendamento/ModalGerenciarSolicitacaoAgendamento.vue